import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=69aaf5d5&scoped=true"
import script from "./Impressum.vue?vue&type=script&lang=ts"
export * from "./Impressum.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aaf5d5",
  null
  
)

export default component.exports